/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { CreateProgramSessionDto } from './create-program-session-dto';
import { EnProgramType } from './en-program-type';
import { EnShared } from './en-shared';
import { JoinEntityDto } from './join-entity-dto';
 /**
 *
 *
 * @export
 * @interface CreateProgramDto
 */
export interface CreateProgramDto {

    /**
     * @type {string}
     * @memberof CreateProgramDto
     */
    title: string;

    /**
     * @type {JoinEntityDto}
     * @memberof CreateProgramDto
     */
    mobility: JoinEntityDto;

    /**
     * @type {EnProgramType}
     * @memberof CreateProgramDto
     */
    type?: EnProgramType | null;

    /**
     * @type {boolean}
     * @memberof CreateProgramDto
     */
    isTemplate?: boolean;

    /**
     * @type {EnShared}
     * @memberof CreateProgramDto
     */
    shared?: EnShared;

    /**
     * @type {string}
     * @memberof CreateProgramDto
     */
    note?: string | null;

    /**
     * @type {Array<CreateProgramSessionDto | JoinEntityDto>}
     * @memberof CreateProgramDto
     */
    sessions: Array<CreateProgramSessionDto | JoinEntityDto>;
}
